import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'ecp-map-dot',
    templateUrl: './map-dot.component.html',
    styleUrls: ['./map-dot.component.css']
})
export class MapDotComponent implements OnInit {
    @Input() ecpStyle: object = {};
    @Input() ecpType: string = 'red-dot';
    public isShowContent = false;

    constructor() {
    }

    ngOnInit() {
        switch (this.ecpType) {
            case 'red-dot':
                this.isShowContent = false;
                break;
            case 'red-location':
                this.isShowContent = true;
                break;
        }
    }

}
